import { useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { CATEGORIES } from '../lib/constants';
import { useListings } from '../hooks/useListings';
import Empty from '../components/Empty';
import Icon from '../components/Icon';
import ListingCard from '../components/ListingCard';

const SORTS = [
  { id: 'nearest', label: 'Nearest' },
  { id: 'price_asc', label: 'Price: low' },
  { id: 'price_desc', label: 'Price: high' },
  { id: 'newest', label: 'Newest' },
];

export default function SearchPage({ browseLocation }) {
  const { search } = useLocation();
  const initial = useMemo(() => new URLSearchParams(search).get('q') || '', [search]);
  const [term, setTerm] = useState(initial);
  const [category, setCategory] = useState('All');
  const [sort, setSort] = useState('nearest');

  const { listings, loading } = useListings({
    category,
    queryText: term,
    location: browseLocation.location,
    radiusMiles: browseLocation.radiusMiles,
    sort,
    enabled: true,
  });

  return (
    <section className="content-page search-page">
      <div className="page-title">
        <h1>Search</h1>
        <p>Explore what your neighbors are selling.</p>
      </div>

      <div className="search-large">
        <Icon name="search" />
        <input
          autoFocus
          value={term}
          onChange={(e) => setTerm(e.target.value)}
          placeholder="Search listings"
        />
      </div>

      <div className="category-row">
        {CATEGORIES.map((x) => (
          <button
            key={x}
            type="button"
            onClick={() => setCategory(x)}
            className={category === x ? 'selected' : ''}
          >
            {x}
          </button>
        ))}
      </div>

      <div className="sort-row">
        {SORTS.map((s) => (
          <button
            key={s.id}
            type="button"
            className={sort === s.id ? 'selected' : ''}
            onClick={() => setSort(s.id)}
          >
            {s.label}
          </button>
        ))}
      </div>

      <div className="section-heading compact">
        <h2>{loading ? 'Searching…' : `${listings.length} results`}</h2>
      </div>

      {listings.length ? (
        <div className="listing-grid">
          {listings.map((item) => (
            <ListingCard key={item.id} item={item} />
          ))}
        </div>
      ) : (
        !loading && (
          <Empty
            icon="search"
            title="Nothing matched that"
            body="Try a broader search or another category."
          />
        )
      )}
    </section>
  );
}
